module.exports = __webpack_public_path__ + "static/media/searchbar.a591bf3d.svg";